import { IconButton, Page, Sidebar } from "@eisox/design-system";
import { PanelLeftIcon } from "@eisox/icons";
import { useMediaQuery } from "@eisox/tools";
import { createFileRoute, useLocation } from "@tanstack/react-router";

import { documentTitleHead } from "~/helpers/document-title.helper";
import { getResourcesUrl } from "~/helpers/resources.helper";
import { m } from "~/paraglide/messages";

export const Route = createFileRoute("/_authenticated/_no-building/resources/$")({
  head: () => documentTitleHead({ page: m.assistance() }),
  component: RouteComponent,
});

function RouteComponent() {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const { _splat: splat } = Route.useParams();
  const { pathname, hash } = useLocation();

  return (
    <Page.Root>
      {isMobile && (
        <Page.Header>
          <Sidebar.Trigger asChild>
            <IconButton>
              <PanelLeftIcon />
            </IconButton>
          </Sidebar.Trigger>
          <Page.Title>{m.assistance()}</Page.Title>
        </Page.Header>
      )}
      <Page.Content className="mt-2.5 md:mt-10">
        <iframe
          id="eisoxDocumentation"
          title="eisox documentation"
          src={getResourcesUrl(import.meta.env.VITE_RESSOURCES_URL, { splat, pathname, hash })}
          className="h-full w-full border-0"
        />
      </Page.Content>
    </Page.Root>
  );
}
